import { createSlice } from '@reduxjs/toolkit';

import { ThunkRequestStatus } from '@fora-monorepo/webapp-types';
import { addOrganizationMetaData } from '@fora-monorepo/webapp-analytics';
import { EmployerViewModel } from '@fora-monorepo/employer-my-pages-common/types';

import { getAdministrableEmployers, getEmployer } from './employerThunks';
import { EmployerState } from './types/index';

const emptyEmployerInfo: EmployerViewModel = {
  agreementNumber: '',
  partnerNumber: '',
  organizationName: '',
  organizationNumber: '',
  vatRegistrationNumber: '',
  companyFormCode: '',
  organizationStatus: '',
  isForeignOrganization: false,
  address: {
    coAddress: '',
    streetAddress: '',
    postalCode: '',
    city: '',
    countryCode: '',
    addressType: '',
  },
  contact: {
    email: '',
    mobile: '',
    phone: '',
  },
  faGroups: [],
  insuranceAgreementValidFromDate: '',
};

export const initialEmployerState: EmployerState = {
  employerInfo: emptyEmployerInfo,
  loadingEmployerInfo: null,
  administrableEmployers: [],
  loadingAdministrableEmployers: ThunkRequestStatus.Pending,
};

const employerSlice = createSlice({
  name: 'employer',
  initialState: initialEmployerState,
  reducers: {
    // Multi mode
    clearSelectedEmployer(state) {
      state.employerInfo = emptyEmployerInfo;
      addOrganizationMetaData(null);
    },
  },
  extraReducers: builder => {
    // Get employer
    builder.addCase(getEmployer.fulfilled, (state, action) => {
      if (action.payload) {
        state.employerInfo = action.payload;

        addOrganizationMetaData(action.payload.partnerNumber);

        state.loadingEmployerInfo = ThunkRequestStatus.Fulfilled;
      }
    });
    builder.addCase(getEmployer.pending, state => {
      state.loadingEmployerInfo = ThunkRequestStatus.Pending;
    });
    builder.addCase(getEmployer.rejected, state => {
      state.loadingEmployerInfo = ThunkRequestStatus.Rejected;
    });
    // Get administrable employers
    builder.addCase(getAdministrableEmployers.fulfilled, (state, action) => {
      if (action.payload) {
        state.loadingAdministrableEmployers = ThunkRequestStatus.Fulfilled;
        state.administrableEmployers = action.payload;
      }
    });
    builder.addCase(getAdministrableEmployers.pending, state => {
      state.loadingAdministrableEmployers = ThunkRequestStatus.Pending;
    });
    builder.addCase(getAdministrableEmployers.rejected, state => {
      state.loadingAdministrableEmployers = ThunkRequestStatus.Rejected;
    });
  },
});

export const { clearSelectedEmployer } = employerSlice.actions;

export const employerReducer = employerSlice.reducer;
export default employerSlice.reducer; // for unit tests
